import { useEffect, useRef, useState } from "react";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import "../../.csscode/PopUpModal.css";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import { Row, Col } from "reactstrap";
import { getDropDownVal } from "../dropdownUtils";
import ObservationDetails from "./ObservationDetails";
import AuditeeHistory from "./AuditeeHistory";
import ReportChoiceModal from "./ReportChoiceModal";
import SuggestionActReferenceModal from "./Sug&actrefpopModal";
import ExportPrint from "./ExportPDFConfirmDialog";
import ExportToWordHTML from "./ExportWordConfirmDialog";
import CustomLoader from "../static/CustomLoader";

const Observation = ({
  selectedId,
  selectedDatacode,
  mode1,
  onHide,
  setRefresh,
  usedCodeList,
  scheduleList,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const today = new Date().toISOString().split("T")[0];
  const userdetails = JSON.parse(localStorage.getItem("user"));
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [user, setUser] = useState("");
  const [scheduleid, setScheduleid] = useState("");
  const [firstNote, setFirstNote] = useState("");
  const [lastNote, setLastNote] = useState("");
  const [observationdate, setObservationdate] = useState(today);
  const [details, setDetails] = useState([]);
  const [mode, setMode] = useState(mode1);
  const [auditcodeList, setAuditcodeList] = useState([{}]);
  const [annextureList, setAnnextureList] = useState([{}]);
  const [divcodeList, setDivcodeList] = useState([{}]);
  const [chapterList, setChapterList] = useState([{}]);
  const [questionList, setQuestionList] = useState([{}]);
  const [SuggandActList, setSuggandActList] = useState([{}]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [emptypeOptions, setEmptypeOptions] = useState([]);
  const [userData, setUserData] = useState([{}]);
  const [empData, setEmpData] = useState([{}]);
  const orgdetails = JSON.parse(localStorage.getItem("org"));
  const suggButtonRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showRefModal, setShowRefModal] = useState(false);

  const [insploading, setInsploading] = useState(false);
  const [auddetails, setAuddetails] = useState([]);
  const [auditeecode, setAuditeecode] = useState("");
  const exportRef = useRef();

  const [errors, setErrors] = useState({});
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  const flattenGroupedDetails = (groupedData) => {
    const flatList = [];

    groupedData.forEach((group) => {
      const { chapter, chapterStatus, questions } = group;

      questions.forEach((q) => {
        flatList.push({
          ...q,
          chapter,
          chapterStatus: chapterStatus || q.chapterStatus || "", // fallback if needed
        });
      });
    });

    return flatList;
  };

  const updateAuditeeFromSchedule = (
    scheduleCode,
    scheduleList,
    setAuditeecode,
  ) => {
    const selectedSchedule = scheduleList.find(
      (item) => item.value === scheduleCode,
    );
    if (selectedSchedule) {
      setAuditeecode(selectedSchedule.auditee);
    }
  };

  useEffect(() => {
    fetchEmpDetailsByCode();
    fetchAudeteeCode();
    fetchEmployee();
    fetchAnnexture();
    fetchDepartment();
    fetchQuestions();
    fetchChapter();
    fetchStatusOptions();
    fetchEmpOptions();
    fetchSuggandActRef();
    fetchData();
  }, []);
  const fetchEmpDetailsByCode = async () => {
    setLoading(true);
    if (selectedId !== "") {
      try {
        const response = await axios.post(
          `${apiUrl}observation/scheduleid/${selectedDatacode}`,
          null,
          { headers },
        );
        if (response.data.cd === 1) {
          toast.info(response.data.description);
          setMode("A"); // Set mode to Add if no data found
          setScheduleid(selectedDatacode);
          updateAuditeeFromSchedule(
            selectedDatacode,
            scheduleList,
            setAuditeecode,
          );
          if (userdetails) {
            setUser(userdetails.empcode);
          }
          setAuddetails([]);
          setDetails([]);
          setFirstNote("");
          setLastNote("");
          setObservationdate(today);
          setId(0);
          setCode(0);
        } else {
          setId(response.data.id);
          setCode(response.data.code);
          setUser(response.data.user);
          setScheduleid(response.data.scheduleid);
          updateAuditeeFromSchedule(
            response.data.scheduleid,
            scheduleList,
            setAuditeecode,
          );
          setObservationdate(response.data.observationdate);
          try {
            const parsedDetails = JSON.parse(response.data.details); // ✅ safely decode JSON string
            const [empDetailArray, groupedDetails, notes] = parsedDetails;

            setAuddetails(empDetailArray[0] || []);
            const flatDetails = flattenGroupedDetails(groupedDetails || []);
            setDetails(flatDetails);
            setFirstNote(notes[0] || "");
            setLastNote(notes[1] || "");
            setMode("U");
          } catch (err) {
            console.error("Invalid JSON in details:", err);
            setDetails([]); // fallback if parse fails
          }
        }
      } catch (error) {
        alert("Error fetching Observation details:", error);
      } finally {
        setLoading(false);
      }
    } else {
      if (userdetails) {
        setUser(userdetails.empcode);
      }
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "observation", { headers })
        .then((response) => {
          //for me
          if (response.data.cd === 1) {
            setUserData([{}]);
          } else {
            setUserData(response.data);
          }
        })
        .catch((error) => {
          console.log("error " + error);
          setUserData([{}]);
        });
    } catch (error) {
      setUserData([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployee = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "employee", { headers })
        .then((response) => {
          //for me
          if (response.data.cd === 1) {
            setEmpData([{}]);
          } else {
            setEmpData(response.data);
          }
        })
        .catch((error) => {
          console.log("error " + error);
          setEmpData([{}]);
        });
    } catch (error) {
      setEmpData([{}]);
    } finally {
      setLoading(false);
    }
  };
  const fetchAudeteeCode = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "auditee", { headers })
        .then((response) => {
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));
          setAuditcodeList(sectionOption);
        })
        .catch(() => setAuditcodeList([{}]));
    } catch {
      setAuditcodeList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSuggandActRef = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "suggandactref", { headers })
        .then((response) => {
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));
          setSuggandActList(response.data);
          setShowRefModal(false);
        })
        .catch(() => setSuggandActList([{}]));
    } catch {
      setSuggandActList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchAnnexture = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "annexture", { headers })
        .then((response) => {
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.filename,
            path: op.path,
          }));
          setAnnextureList(sectionOption);
        })
        .catch(() => setAnnextureList([{}]));
    } catch {
      setAnnextureList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartment = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "division", { headers })
        .then((response) => {
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));
          setDivcodeList(sectionOption);
        })
        .catch(() => setDivcodeList([{}]));
    } catch {
      setDivcodeList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "question", { headers })
        .then((response) => {
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.question,
            parent: op.parent,
            chaptercode: op.chaptercode,
          }));
          setQuestionList(sectionOption);
        })
        .catch(() => setQuestionList([{}]));
    } catch {
      setQuestionList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchChapter = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "chapter", { headers })
        .then((response) => {
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.chapter,
            label2: op.name,
          }));
          setChapterList(sectionOption);
        })
        .catch(() => setChapterList([{}]));
    } catch {
      setChapterList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchStatusOptions = () => {
    try {
      const response = getDropDownVal("DEPS");
      const actOption = response.map((op) => ({
        value: op.code,
        label: op.value,
      }));
      setStatusOptions(actOption);
    } catch {
      console.log("error");
    }
  };
  const fetchEmpOptions = () => {
    try {
      const response = getDropDownVal("EMPTP");
      const actOption = response.map((op) => ({
        value: op.code,
        label: op.value,
      }));
      setEmptypeOptions(actOption);
    } catch {
      console.log("error");
    }
  };

  function clearFields() {
    setUser(user ? user : "");
    setScheduleid(scheduleid ? scheduleid : "");
    setObservationdate(today);
    setDetails([]);
    setFirstNote("");
    setLastNote("");
  }

  const validateFields = () => {
    let errors = {};

    if (!user) errors.user = "User is required...";
    if (!observationdate)
      errors.observationdate = "Observationdate Date is required...";
    if (!scheduleid) errors.scheduleid = "scheduleid is required...";
    if (auddetails.length < 1) {
      errors.auddetails = "Please Add Basic details.";
    }
    return errors;
  };

  const handlesubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const fieldErrors = validateFields();
    setErrors(fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct all required input fields.");
      setLoading(false);
      return;
    } else {
      const isValid = details.every((item) => {
        if (item.department) {
          return item.startdate && item.enddate;
        }
        return true;
      });

      if (!isValid) {
        alert("Please fill Start and End Dates for all selected departments.");
        setLoading(false);
        return;
      }
    }
    const transformDetailsToGrouped = (details) => {
      const groupedMap = {};

      details.forEach((item) => {
        const chapterKey = item.chapter;
        if (!groupedMap[chapterKey]) {
          groupedMap[chapterKey] = {
            chapter: chapterKey,
            chapterStatus: item.chapterStatus || "",
            questions: [],
          };
        }

        const { chapter, chapterStatus, ...questionData } = item;

        groupedMap[chapterKey].questions.push(questionData);
      });

      return Object.values(groupedMap);
    };

    const departmentTasksList = details
      .filter((item) => item.department) // only include items with department
      .map((item) => ({
        scheduleid: scheduleid,
        chapter: item.chapter,
        questionno: item.questionId,
        divcode: item.department, // 'divcode' = department
        assigneduser: userdetails.empcode,
        assigneddate: today,
        startdate: item.startdate,
        enddate: item.enddate,
        status: parseInt(item.status) ? parseInt(item.status) : 1, // default to "Pending" if status is not set
      }));

    const formData = {
      id,
      code,
      user,
      scheduleid,
      observationdate,
      details: JSON.stringify([
        [auddetails], // 0: audit/factory info
        transformDetailsToGrouped(details), // 1: grouped observation data
        [
          firstNote || "", // 2: firstNote and lastNote (optional)
          lastNote || "",
        ],
      ]),
    };
    try {
      if (mode === "A") {
        if (mode === "A") {
          setId(0);
          setCode(0);
        }
        const response = await axios.post(apiUrl + "observation", formData, {
          headers,
        });
        const response1 = await axios.post(
          apiUrl + "deptTasks",
          departmentTasksList,
          { headers },
        );
        if (response.data.cd === 1) {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
        } else {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
        }
      } else {
        const response = await axios.put(apiUrl + "observation", formData, {
          headers,
        });
        const response1 = await axios.post(
          apiUrl + "deptTasks",
          departmentTasksList,
          { headers },
        );
        if (response.data.cd === 1) {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
        } else {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
        }
      }
    } catch (error) {
      alert("Some issue. Please check with Administrator..!", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleView1stInspection = (e) => {
    e.preventDefault();
    if (!auditeecode) {
      toast.error(
        "Please select Schedule or Factory details in schedule is empty.",
      );
      return;
    } else {
      setInsploading(true);
    }
  };

  const handleClose1stInspection = () => {
    setInsploading(false);
    setAuditeecode(auditeecode ? auditeecode : "");
  };
  const handleGenerateClick = () => {
    setShowModal(true);
  };

  const fetchImagesAsBase64 = async (urls) => {
    const results = await Promise.all(
      urls.map(async (url) => {
        try {
          const response = await fetch(
            "https://gammazenigma.co.in/files/upload/p/06/ptw12345/05.jpg",
            { mode: "no-cors" },
          ); // No effect for binary data
          const blob = await response.blob();
          return await blob.arrayBuffer();
        } catch (e) {
          console.warn("Failed to fetch image:", url, e.message);
          return null; // Skip the failed image
        }
      }),
    );
    return results.filter(Boolean); // Remove nulls
  };

  const prepareDetailsWithImages = async (details) => {
    const withImages = await Promise.all(
      details.map(async (item) => {
        const imageBuffers = await fetchImagesAsBase64(item.image || []);
        const responseBuffers = await fetchImagesAsBase64(
          item.responseImages || [],
        );
        return { ...item, imageBuffers, responseBuffers };
      }),
    );
    return withImages;
  };

  const handleFormatSelect = async (format) => {
    setShowModal(false);
    if (format === "pdf") {
      exportRef.current?.print();
    } else if (format === "word") {
      document.getElementById("word-export-btn")?.click();
    }
  };

  const handleUserChange = (selectedOption) =>
    setUser(selectedOption ? selectedOption.value : "");
  const handlescheduleChange = (selectedOption) => {
    const selectedScheduleId = selectedOption ? selectedOption.value : "";
    const selectedAudetee = selectedOption ? selectedOption.auditee : "";

    if (mode === "A" && selectedScheduleId && userData.length > 0) {
      const alreadyInspected = userData.some(
        (entry) => entry.scheduleid === selectedScheduleId,
      );

      if (alreadyInspected) {
        alert("This Inspection is already initiated for this schedule.");
        return; // prevent selection
      }
    }
    setAuditeecode(selectedAudetee);
    setScheduleid(selectedScheduleId);
  };
  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999",
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)",
    }),
  };

  return (
    <>
      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />
      <div className="popupmodal-maindiv">
        <Row>
          <Col md={6}>
            <FormGroup className="mb-3">
              <Label className="font-weight-bold">Auditeer/Inspector</Label>
              <Select
                name="user"
                isClearable
                required
                value={
                  user
                    ? usedCodeList.find((option) => option.value === user)
                    : null
                }
                isDisabled={true}
                onChange={handleUserChange}
                placeholder="Select Employee"
                options={usedCodeList}
                styles={customStyles}
                classNamePrefix="select"
              />
              {errors.user && (
                <span className="error-message">{errors.user}</span>
              )}
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup className="mb-3">
              <Label className="font-weight-bold">Schedule</Label>
              <Select
                name="schedule"
                isClearable
                required
                isDisabled={mode === "U"}
                value={
                  scheduleid
                    ? scheduleList.find((option) => option.value === scheduleid)
                    : null
                }
                onChange={handlescheduleChange}
                placeholder="Select Schedule"
                options={scheduleList}
                styles={customStyles}
                classNamePrefix="select"
              />
              {errors.scheduleid && (
                <span className="error-message">{errors.scheduleid}</span>
              )}
            </FormGroup>
          </Col>
          <Col md={6}>
            <label>Observation Date</label>
            <Tooltip title="Start Date">
              <input
                type="date"
                placeholder="Observation Date"
                required
                value={observationdate}
                onChange={(e) => setObservationdate(e.target.value)}
                className={"form-control mb-2"}
              />
            </Tooltip>
            {errors.observationdate && (
              <span className="error-message">{errors.observationdate}</span>
            )}
          </Col>
          <Col md={6}>
            <div className="my-3">
              <button
                type="button"
                className="btn btn-primary"
                style={{ padding: "14px 28px" }}
                disabled={loading || insploading}
                onClick={handleView1stInspection}
              >
                Basic Details
              </button>
              {/* <button type="button" class="btn btn-dark" disabled={loading} onClick={handleGenerateClick}>
                Generate Report
              </button> */}
              <ExportPrint
                ref={exportRef}
                orgdetails={orgdetails}
                auddetails={auddetails}
                details={details}
                firstNote={firstNote}
                lastNote={lastNote}
                chapterList={chapterList}
                divcodeList={divcodeList}
                annextureList={annextureList}
                statusOptions={statusOptions}
                emptypeOptions={emptypeOptions}
                scheduleid={scheduleid}
                observationdate={observationdate}
                user={user}
                empData={empData}
                mode="I"
              />
              <ExportToWordHTML
                orgdetails={orgdetails}
                auddetails={auddetails}
                details={details}
                firstNote={firstNote}
                lastNote={lastNote}
                chapterList={chapterList}
                divcodeList={divcodeList}
                annextureList={annextureList}
                statusOptions={statusOptions}
                emptypeOptions={emptypeOptions}
                scheduleid={scheduleid}
                observationdate={observationdate}
                user={user}
                empData={empData}
                mode="I"
              />
            </div>
          </Col>
          <Col md={12}>
            <FormGroup className="mb-3">
              <h5 className="font-weight-bold">First Note</h5>
              <textarea
                className="form-control"
                onDoubleClick={async () => {
                  try {
                    const text = await navigator.clipboard.readText();
                    setFirstNote(text);
                  } catch (err) {
                    console.error("Failed to paste from clipboard:", err);
                  }
                }}
                value={firstNote}
                rows={3}
                placeholder="Enter First Note..."
                onChange={(e) => setFirstNote(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
        <div className="my-3">
          {insploading && (
            <AuditeeHistory
              selectedId={auditeecode}
              mode="U"
              onHide={handleClose1stInspection}
              divData={divcodeList}
              employeeTypeOptions={empData}
              setAuddetails={setAuddetails}
              auddetails={auddetails}
              usedCodeList={usedCodeList}
            />
          )}
        </div>
        <div className="my-3">
          <ObservationDetails
            selectedDatacode={selectedDatacode}
            chapterList={chapterList}
            questionList={questionList}
            divcodeList={divcodeList}
            statusOptions={statusOptions}
            annextureList={annextureList}
            details={details}
            setDetails={setDetails}
            handlesubmit={handlesubmit}
            mode={mode}
          />
        </div>
        <ReportChoiceModal
          show={showModal}
          onClose={() => setShowModal(false)}
          onSelect={handleFormatSelect}
        />

        <FormGroup className="mb-3">
          <h5 className="font-weight-bold">closing Note</h5>
          <textarea
            className="form-control"
            value={lastNote}
            rows={3}
            placeholder="Enter closing note..."
            onDoubleClick={async () => {
              try {
                const text = await navigator.clipboard.readText();
                setLastNote(text);
              } catch (err) {
                console.error("Failed to paste from clipboard:", err);
              }
            }}
            onChange={(e) => setLastNote(e.target.value)}
          />
        </FormGroup>
        <div className="bottombtn d-grid gap-2 d-md-flex justify-content-md-end">
          {SuggandActList.length > 0 && (
            <button
              className="btn btn-outline-info"
              ref={suggButtonRef}
              onClick={() => setShowRefModal(true)}
            >
              Open Suggestions / Act References
            </button>
          )}
          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handlesubmit}
          >
            Save
          </button>
        </div>
        {loading && <CustomLoader />}
      </div>
      {showRefModal && (
        <SuggestionActReferenceModal
          open={showRefModal}
          onClose={() => setShowRefModal(false)}
          data={SuggandActList}
        />
      )}
    </>
  );
};

export default Observation;
